export default __webpack_public_path__ + "static/media/panel.154dd1ff.png";